<template>
  <Row>
    <Col :xs="24" :sm="24" :md="24" :lg="24" style="text-align:center;">
      <chart :options="detailOption" style="height: 300px;" class="echarts" id="detailChart"
             ref="detailChart"></chart>
    </Col>
  </Row>
</template>
<script>

  import echarts from 'echarts'

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  let posList = [
    'left', 'right', 'top', 'bottom',
    'inside',
    'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
    'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
  ];

  export default {
    name: 'memhourly',
    components: {
      echarts
    },
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        detailChartConfig: {
          configParameters: {
            rotate: {
              min: -90,
              max: 90
            },
            align: {
              options: {
                left: 'left',
                center: 'center',
                right: 'right'
              }
            },
            verticalAlign: {
              options: {
                top: 'top',
                middle: 'middle',
                bottom: 'bottom'
              }
            },
            position: {
              options: echarts.util.reduce(posList, function (map, pos) {
                map[pos] = pos
                return map
              }, {})
            },
            distance: {
              min: 0,
              max: 100
            }
          },

          config: {
            rotate: 90,
            align: 'left',
            verticalAlign: 'middle',
            position: 'insideBottom',
            distance: 15,
            onChange: () => {
              var labelOption = {
                normal: {
                  rotate: this.detailChartConfig.config.rotate,
                  align: this.detailChartConfig.config.align,
                  verticalAlign: this.detailChartConfig.config.verticalAlign,
                  position: this.detailChartConfig.config.position,
                  distance: this.detailChartConfig.config.distance
                }
              };

              this.$refs.detailChart.setOption({
                series: [{
                  label: labelOption
                }, {
                  label: labelOption
                }, {
                  label: labelOption
                }, {
                  label: labelOption
                }]
              });
            }
          }
        },

        detailOption: {
          title: {text: '内存小时统计报表'},
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          calculable: true,
          toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
              mark: {show: true},
              dataView: {show: true, readOnly: false},
              magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
              restore: {show: true},
              saveAsImage: {show: true}
            }
          },
          legend: {
            data: ['JVM在用总内存', 'JVM空闲内存', 'JVM最大获取内存', '系统总内存', '系统空闲内存', '系统已用内存']
          },
          xAxis: [{
            type: 'category',
            axisTick: {show: false},
            data: ['1', '2']
          }],
          yAxis: [{
            type: 'value'
          }],
          series: []
        }
      }
    },
    methods: {
      ...mapActions([
        'SystemInfoServ_GetSystemInfo'
      ]),
      loadData() {
        store.dispatch('MemMinutelyServ_GetHourly', {
          params: {selectDatetime: new Date().Format('yyyy-MM-dd hh:mm:ss')}
        }).then(() => {

            let result = store.getters.get_MemMinutely_GetHourlyResult

            this.detailOption.xAxis[0].data = []
            // result.forEach((item, index) => {
            //   this.detailOption.xAxis[0].data.push(index + 1)
            // })
            for (let i = 0; i < 60; i++) {
              this.detailOption.xAxis[0].data.push(i + 1)
            }

            let labelOption = {
              normal: {
                show: false,
                position: this.detailChartConfig.config.position,
                distance: this.detailChartConfig.config.distance,
                align: this.detailChartConfig.config.align,
                verticalAlign: this.detailChartConfig.config.verticalAlign,
                rotate: this.detailChartConfig.config.rotate,
                formatter: '{c} {name|{a}}',
                fontSize: 16,
                rich: {
                  name: {
                    textBorderColor: '#fff'
                  }
                }
              }
            }

            let jvmTotalMem = {
              name: 'JVM在用总内存',
              type: 'bar',
              barGap: 0,
              label: labelOption,
              data: []
            }

            let jvmFreeMem = {
              name: 'JVM空闲内存',
              type: 'bar',
              label: labelOption,
              data: []
            }

            let jvmMaxMem = {
              name: 'JVM最大获取内存',
              type: 'bar',
              label: labelOption,
              data: []
            }

            let totalMem = {
              name: '系统总内存',
              type: 'bar',
              label: labelOption,
              data: []
            }

            let freeMem = {
              name: '系统空闲内存',
              type: 'bar',
              label: labelOption,
              data: []
            }

            let usedMem = {
              name: '系统已用内存',
              type: 'bar',
              label: labelOption,
              data: []
            }

            result.forEach(item => {
              if (item) {
                item.forEach(subItem => {
                  if (subItem.calculateType === 1) {
                    jvmTotalMem.data.push(subItem.count)
                  } else if (subItem.calculateType === 2) {
                    jvmFreeMem.data.push(subItem.count)
                  } else if (subItem.calculateType === 3) {
                    jvmMaxMem.data.push(subItem.count)
                  } else if (subItem.calculateType === 4) {
                    totalMem.data.push(subItem.count)
                  } else if (subItem.calculateType === 5) {
                    freeMem.data.push(subItem.count)
                  } else if (subItem.calculateType === 6) {
                    usedMem.data.push(subItem.count)
                  }
                })
              } else {
                jvmTotalMem.data.push(0)
                jvmFreeMem.data.push(0)
                jvmMaxMem.data.push(0)
                totalMem.data.push(0)
                freeMem.data.push(0)
                usedMem.data.push(0)
              }
            })

            this.detailOption.series = [jvmTotalMem, jvmFreeMem, jvmMaxMem, totalMem, freeMem, usedMem]
          }
        ).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if (val) {

        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        }
        ,
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      }
    }
    ,
    mounted() {
      this.$nextTick(() => {
        this.loadData()
      })
    }
  }
</script>
<style lang="less">
  .count-style{
    font-size: 50px;
  }

  .echarts {
    border-radius: 4px;
    height: 300px;
    width: 90%;
  }
</style>
